<template>

    <v-card >
        <v-card-title>{{$t('simulacion.modulo.almacenamiento.titulo')}}</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
            <v-row>
            <v-col cols="12">
                
                <v-container>
                    <!--
                    <v-form v-model="valid" lazy-validation>
                    <v-row>
                        <v-col v-for="(value, key) in filteredDatos" :key="key" cols="12" sm="3">
                          <v-text-field v-if="!campos_ocultos.includes(key)"
                              density="compact"  
                              variant="outlined" 
                              :label="formatLabel(key)"
                              v-model.number="datos[key]"
                              :type="getFieldType(key)"                              
                              :hint="getHint(key)"
                              @input="updateValue" 
                          ></v-text-field>
                        </v-col>
                    </v-row>                    
                    </v-form>
                     -->

                    <v-row>
                      <v-col cols="3" sm="3">
                        <v-text-field
                          density="compact"
                          rounded="sm"
                          variant="outlined"
                          :label="formatLabel('pdia')"
                          :model-value="pdia"
  @update:modelValue="val => pdia = val"
  @input="updateValue"
                          :rules="[rules.Negativo]"
                        ></v-text-field>
                      </v-col>

                      <v-col cols="3" sm="3">
                        <v-text-field
                          density="compact"
                          rounded="sm"
                          variant="outlined"
                          :label="formatLabel('piny')"
                          :model-value="formatNumber(piny)"
                          @update:modelValue="val => piny = Number(val.replace(',', '.'))"
                          
                          @input="updateValue"
                          :rules="[rules.Negativo]"
                        ></v-text-field>
                      </v-col>

                      <v-col cols="3" sm="3">
                        <v-text-field
                          density="compact"
                          rounded="sm"
                          variant="outlined"
                          :label="formatLabel('pext')"
                          :model-value="formatNumber(pext)"
                          @update:modelValue="val => pext = Number(val.replace(',', '.'))"
                          
                          @input="updateValue"
                          :rules="[rules.Negativo]"
                        ></v-text-field>
                      </v-col>
                    </v-row>

                   <!--   <v-col cols="3" sm="3">
                        <v-text-field
                            density="compact"
                            rounded='sm'
                            variant="outlined"
                            :label="formatLabel('capexf')"
                            v-model.number="datos['capexf']"
                            type="number"                            
                            @input="updateValue" 
                        ></v-text-field>
                      </v-col>
                      <v-col cols="3" sm="3">
                        <v-text-field
                            density="compact"
                            rounded='sm'
                            variant="outlined"
                            :label="formatLabel('capexv')"
                            v-model.number="datos['capexv']"
                            type="number"                            
                            @input="updateValue" 
                        ></v-text-field>
                      </v-col>-->
                    
                    
                    <v-row>
                      <v-col cols="3" sm="3">
                        <v-typography variant="h1">
                          {{ $t('simulacion.modulo.electrolizador.datos_economicos') }}
                        </v-typography>                                              
                      </v-col>
                    </v-row>
                    <v-row>
                    <v-col cols="12" sm="6">
                      <v-switch
                        v-model="usarCurvasBOP"
                        :label="$t('simulacion.modulo.curvas_CAPEXOPEX.capex_opex_curvas')"
                        inset
                        hide-details
                        color="blue"         
                        track-color="grey"
                      />
                    </v-col>
                  </v-row>
                    <v-row v-if="!usarCurvasBOP">
                      <v-col cols="3" sm="3">
                        <ComponenteEditorCAPEXOPEX
                        :titulo="$t('simulacion.modulo.almacenamiento.capex')"
                        v-model:valorVariable="datos.capexv"
                        v-model:valorFijo="datos.capexf"
                        unidad-variable="kEUR/tonH2"
                        unidad-fijo="kEUR"
                        />
                      </v-col>


                      <v-col cols="3" sm="3">
                        <ComponenteEditorCAPEXOPEX
                        :titulo="$t('simulacion.modulo.almacenamiento.opex')"
                        v-model:valorVariable="datos.opexv"
                        v-model:valorFijo="datos.opexf" 
                        unidad-variable="kEUR/tonH2 año"
                        unidad-fijo="kEUR año"
                        />
                      </v-col>
                      <!--
                      <v-col cols="3" sm="3">
                        <ComponenteEditorCAPEXOPEX titulo="Capex BOP (EUR/MW almacenamiento):"/>
                      </v-col>

                      <v-col cols="3" sm="3">
                        <ComponenteEditorCAPEXOPEX titulo="Capex Reemplazo stacks (EUR/MW):"/>
                      </v-col> 
                      -->
                    </v-row>   

                </v-container>

            </v-col>
            </v-row>
        </v-card-text>
    </v-card>



</template>

<script>
import ComponenteEditorCAPEXOPEX from '../components/ComponenteEditorCAPEXOPEX.vue';
export default {
  props: {
    modelValue: { // Recibe el valor desde el padre
      type: Object,
      required: true,
    },
    usarCapexOpexGeneralAlmacenamiento: String
  },

  components: {
    ComponenteEditorCAPEXOPEX,
  },

  computed: {
    filteredDatos() {
      return Object.fromEntries(
        Object.entries(this.datos).filter(([key]) => !this.campos_ocultos.includes(key))
      );
    },

    pdia: {
  get() {        
    const value = this.datos.pdia;
    return this.formatNumber(value * 100);
  },
  set(value) {        
    const numericValue = Number(value.replace(',', '.')) / 100;
    this.datos.pdia = isNaN(numericValue) ? 0 : numericValue;
  },
  },

    piny: {
          get() {        
            const value = this.datos.piny 
            return (value * 100).toFixed(2)               
          },
          set(value) {        
            const numericValue = value / 100;
            this.datos.piny = isNaN(numericValue) ? 0 : numericValue;
          },
        },
    pext: {
      get() {        
        const value = this.datos.pext 
        return (value * 100).toFixed(2)               
      },
      set(value) {        
        const numericValue = value / 100;
        this.datos.pext = isNaN(numericValue) ? 0 : numericValue;
      },
    },
    usarCurvasBOP: {
      get() {
        return this.datos.curvas?.capex === 1 && this.datos.curvas?.opex === 1;
      },
      set(val) {
        this.datos.curvas.capex = val ? 1 : 0;
        this.datos.curvas.opex = val ? 1 : 0;
      }
    }

  },


  data() {
    return {
      valid: false,
      datos: { ...this.modelValue }, // Inicializa los datos con el valor recibido
      labels: {
        pdia: this.$t('simulacion.modulo.almacenamiento.pdia'),
        piny: this.$t('simulacion.modulo.almacenamiento.piny'),
        pext: this.$t('simulacion.modulo.almacenamiento.pext'),
        cele: this.$t('simulacion.modulo.almacenamiento.cele'),
        capexf: this.$t('simulacion.modulo.almacenamiento.capexf'),
        capexv: this.$t('simulacion.modulo.almacenamiento.capexv'),
        calmfija: this.$t('simulacion.modulo.almacenamiento.calmfija')
      },
      campos_ocultos: ["cele","calmfija","cmax"],
      rules: {
        required: v => !!v || this.$t('mensajes.campo_requerido'),
        Negativo: (v) => {
        const num = Number(v.toString().replace(',', '.'));
          return isNaN(num) ? 'Valor inválido' : (num >= 0 ? true : 'El valor no puede ser negativo');
        },
      },
      usarCapexOpexGeneral: this.usarCapexOpexGeneralAlmacenamiento || 'especifico'
    };
  },

  watch: {
    // Vigila los cambios en `datos` y emite el evento cuando cambian
    datos: {
      handler(newDatos) {
        this.$emit('update:modelValue', newDatos);
      },
      deep: true, // Escucha los cambios profundos dentro de `datos`
    },


    '$i18n.locale'() {                
      this.labels.pdia = this.$t('simulacion.modulo.almacenamiento.pdia')
      this.labels.piny = this.$t('simulacion.modulo.almacenamiento.piny')
      this.labels.pext = this.$t('simulacion.modulo.almacenamiento.pext')
      this.labels.cele = this.$t('simulacion.modulo.almacenamiento.cele')
      this.labels.capexf = this.$t('simulacion.modulo.almacenamiento.capexf')
      this.labels.capexv = this.$t('simulacion.modulo.almacenamiento.capexv')
      this.labels.calmfija = this.$t('simulacion.modulo.almacenamiento.calmfija')
    },


  },
  methods: {

    actualizarDatos(){

        this.datos={...this.modelValue 
      }

      },


    formatNumber(value) {
      if (value === null || value === undefined || value === '') return '';
      if (typeof value !== 'number') value = Number(value);

      // Si es entero, no ponemos decimales
      if (Number.isInteger(value)) {
        return value.toString().replace('.', ',');
      } else {
        // Si tiene decimales, mostramos con coma
        return value.toString().replace('.', ',');
      }
    },
    formatLabel(key) {
      let out = key.charAt(0).toUpperCase() + key.slice(1)
      out = this.labels[key]
      return out;
    },
    getFieldType(key) {
      if (key === 'capac' || key === 'capex' || key === 'nfijo') {
        return 'number';
      }
      return 'text';
    },
    getHint(key) {
      if (key === 'capex') {
        return 'In currency';
      }
      return '';
    },
    saveData() {
      console.log('Data saved:', this.datos);
    },
    emitirOpcionGeneral() {
      this.$emit('update:usarCapexOpexGeneralAlmacenamiento', this.usarCapexOpexGeneral);
    }
  },



};
</script>

<style scoped>
.v-btn {
  margin-top: 20px;
}
</style>
